import { graphql } from '@gql';

export const GET_USER = graphql(`
    query getUser($id: ID!) {
        users(where: { id: $id }) {
            totalCount
            edges {
                node {
                    ...MinimalUserPartial
                }
            }
        }
    }
`);

export const GET_USER_DETAILS = graphql(`
    query getUserDetails($id: ID!) {
        users(where: { id: $id }) {
            totalCount
            edges {
                node {
                    ...MinimalUserPartial
                    gid
                    orgCode
                    location
                    are
                    admin
                    active
                    organizations {
                        id
                        organization {
                            id
                            name
                        }
                        role
                    }
                }
            }
        }
    }
`);

export const GET_USERS_FOR_SELECT = graphql(`
    query GetUsersForSelect($where: UserWhereInput, $first: Int) {
        users(where: $where, first: $first) {
            edges {
                node {
                    ...MinimalUserPartial
                }
            }
        }
    }
`);

export const GET_USERS = graphql(`
    query GetUsers($where: UserWhereInput) {
        users(where: $where) {
            totalCount
            edges {
                node {
                    ...MinimalUserPartial
                    gid
                    orgCode
                    location
                    are
                    admin
                    active
                    organizations {
                        id
                        organization {
                            id
                            name
                        }
                        role
                    }
                }
            }
        }
    }
`);

export const GET_USERS_FOR_ADMIN = graphql(`
    query GetUsersForAdmin($where: UserWhereInput, $first: Int) {
        users(where: $where, first: $first) {
            totalCount
            edges {
                node {
                    ...MinimalUserPartial
                    gid
                    orgCode
                    location
                    are
                    admin
                    active
                }
            }
        }
    }
`);

export const GET_ICSO_USERS = graphql(`
    query GetIcsoUsers {
        users(where: { hasOrganizationUsersWith: { role: ICSO } }) {
            edges {
                node {
                    ...MinimalUserPartial
                }
            }
        }
    }
`);

export const GET_USER_OF_PROJECT = graphql(`
    query usersOfProject($projectId: ID!) {
        users(where: { hasProjectsWith: { id: $projectId } }) {
            totalCount
            edges {
                node {
                    ...MinimalUserPartial
                    organizations {
                        role
                    }
                }
            }
        }
    }
`);

export const FIND_USERS = graphql(`
    query FindUsers($search: String!) {
        users(
            where: {
                or: [
                    { firstNameContainsFold: $search }
                    { lastNameContainsFold: $search }
                ]
                active: true
            }
        ) {
            edges {
                node {
                    ...MinimalUserPartial
                }
            }
        }
    }
`);

export const ME = graphql(`
    query GetMe {
        me {
            ...MinimalUserPartial
            gid
            orgCode
            location
            are
            admin
            active
        }
    }
`);

export const GET_USER_NOTIFICATION_SETTINGS = graphql(`
    query GetUserNotificationSettings {
        userNotificationSetting {
            id
            userID
            enable
            frequency
            projects {
                id
                priorityEnabled
                cvssEnabled
                cvssMinScore
                assetsAndZonesEnabled
                assignedOnly
                priority
                tasksEnabled
                vulnerabilitiesEnabled
            }
        }
    }
`);
